import { isAuth } from "./auth.service";
import getAuthConfig from "../config/auth.config";
const CACHE_KEY_PREFIX = '@@auth0spajs@@';
export async function get(url) {
    return doFetch(url, 'GET');
}
export async function put(url, body) {
    return doFetch(url, 'PUT', body);
}
export async function post(url, body) {
    return doFetch(url, 'POST', body);
}
export async function del(url) {
    return doFetch(url, 'DELETE');
}
let getIdToken;
isAuth.subscribe(authenticated => {
    if (!authenticated) {
        getIdToken = null;
    }
});
async function doFetch(url, method, body) {
    getIdToken = getIdToken || lazyGetIdTokenGetter();
    const res = await fetch(url, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getIdToken()}`
        },
        method: method,
        body: JSON.stringify(body)
    });
    const data = await res.json();
    if (res.ok) {
        return data;
    }
    else {
        throw new Error(data);
    }
}
function lazyGetIdTokenGetter() {
    let idToken = '';
    return () => {
        if (idToken) {
            return idToken;
        }
        idToken = getIdTokenFromStorage();
        return idToken;
    };
}
function getIdTokenFromStorage() {
    const authConfig = getAuthConfig();
    const cachePrefix = `${CACHE_KEY_PREFIX}::${authConfig.clientId}`;
    const key = findCacheKey(cachePrefix);
    const bodyTokenRaw = window.localStorage.getItem(key);
    const bodyToken = JSON.parse(bodyTokenRaw);
    return bodyToken.body.id_token;
}
function findCacheKey(prefix) {
    for (let i = 0; i < window.localStorage.length; i++) {
        const key = window.localStorage.key(i);
        if (key.startsWith(prefix)) {
            return key;
        }
    }
}
